import type { Iso3166Alpha3Lower, LocaleCode } from "../types";

import { findLocaleCodeFromIso3166Alpha3Lower } from "../registry/find-locale-code-from-iso3166-alpha3-lowercase";
import { LOCALE_DEFINITIONS } from "../registry/locale-registry-data";

const ENV_WEBSITE_COUNTRY_PATTERN = /^[a-z]{3}$/;

function resolveLocaleCodeFromEnv(
  envWebsiteCountry: string | null | undefined,
): LocaleCode | null {
  const normalized = envWebsiteCountry?.trim().toLowerCase();

  if (!normalized || !ENV_WEBSITE_COUNTRY_PATTERN.test(normalized)) {
    return null;
  }

  return findLocaleCodeFromIso3166Alpha3Lower(
    normalized as Iso3166Alpha3Lower,
    LOCALE_DEFINITIONS,
  );
}

export { resolveLocaleCodeFromEnv };
